import React from "react";
import { graphql, StaticQuery } from "gatsby";
import { RichText as PrismicRichText } from "prismic-reactjs";

import { SEO } from "src/components";

import Grid from "./_components/_grid";

const IndexPage = ({ preview }) => (
  <StaticQuery
    query={graphql`
      {
        prismicHome {
          dataString
        }
      }
    `}
    render={data => {
      let page = JSON.parse(data.prismicHome.dataString);
      if (preview) {
        page = preview;
      }
      return (
        <>
          <SEO
            image={page.seo_image && page.seo_image.url}
            title={page.seo_title && PrismicRichText.asText(page.seo_title)}
            description={
              page.seo_description &&
              PrismicRichText.asText(page.seo_description)
            }
          />
          <Grid tiles={page.tiles} />
        </>
      );
    }}
  />
);

export default IndexPage;
